var scrollObject = {};

function getScrollDistance() {
    scrollObject = {
        x: window.pageXOffset,
        y: window.pageYOffset
    }

    const announcements = document.querySelector('.announcement-bar-section');
    const announcementOffset = (announcements !== null) ? announcements.offsetHeight : 0;

    if (scrollObject.y > announcementOffset) {
        document.body.classList.add('scrolled');
    } else {
        document.body.classList.remove('scrolled');
    }
}

window.onscroll = function () {
    getScrollDistance();
};

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const searchButton = document.getElementById('header-search');
const predictiveSearchField = document.getElementById('Search-In-Template');
if (searchButton !== null && predictiveSearchField !== null) {
    searchButton.onclick = function (e) {
        e.preventDefault();
        searchButton.classList.toggle('active');
        document.body.classList.toggle('show-predictive-search');
        predictiveSearchField.focus();
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': `application/${type}`
        }
    };
}
